<template>
  <order-dialog-box  class="buy_method" :title="buyMethod.name">
    <template #content>
      <div class="info">
        <el-radio-group v-model="buyMethodComputed.value" @change="$emit('change', buyMethod.type)">
          <el-radio :label="idx" v-for="(ratio, idx) in buyMethod.ratios" :key="idx">
              <span>
                {{ratio.label}}/<span style="color: red">{{ratio.money}}￥</span>
              </span>
          </el-radio>
        </el-radio-group>
      </div>
      <order-pay-methods :name="buyMethod.name" :type="buyMethod.type"
                         :pay-disabled="payDisabled" v-on="$listeners"></order-pay-methods>
    </template>
  </order-dialog-box>
</template>

<script>


import OrderDialogBox from "@/components/OrderDialog/OrderDialogBox";
import OrderPayMethods from "@/components/OrderDialog/orderPayMethods";
export default {
  name: "OrderBuyMethodItem",
  components: {OrderPayMethods, OrderDialogBox},
  props: {
    buyMethod: Object,
    payDisabled: Boolean,
  },
  data(){
    return {
      BALANCE: 0,
      WX: 1,
      ALIPAY: 2,
    }
  },
  methods: {
    payClick(payMethod, buyMethod, type) {
      this.$emit('pay-click', payMethod, buyMethod, type)
    }
  },
  computed:{
    buyMethodComputed(){
      return this.buyMethod;
    }
  }
}
</script>

<style lang="less">
  .buy_method {
    .info p {
      margin: 0px;
      padding: 3px;
      font-size: 12px;
      color: #F56C6C;
    }

    .info .el-radio-group {
      padding: 10px 0 0;
      width: 100%;
    }

    .info .el-radio {
      margin: 0;
      width: 33%;
    }

    .info .el-radio__label {
      padding-left: 0px;
      font-size: 12px;
    }


    .scan_code_div {
      float: right;
      display: inline-block;
      height: 40px;
    }

    .scan_code_div .scan_code {
      float: left;
      margin: 10px 5px;
      width: 20px;
      height: 20px;
    }

    .scan_code_div button {
      padding: 0;
      line-height: 40px;
    }

    .scan_code_div .el-checkbox, .scan_code_div .el-checkbox__input, .scan_code_div .el-checkbox__label {
      line-height: 40px;
      height: 40px;
      display: inline-block;
      padding-left: 3px;
    }

    .scan_code_div .el-checkbox__input .el-checkbox__inner {
      margin: 11px 0;
    }

  }
</style>